export const DESIRED_COUNT_MINIMUM = 1;
export const DESIRED_COUNT_MAXIMUM = 20;
export const DESIRED_COUNT_DEFAULT = 5;
export const NUMBER_OF_VALUE_MINIMUM = 1;
export const NUMBER_OF_VALUE_DEFAULT = 8;
